import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "angle-down_ed83570010c5c7becbf97254e05bbe88",
  "use": "angle-down_ed83570010c5c7becbf97254e05bbe88-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"angle-down_ed83570010c5c7becbf97254e05bbe88\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.5 10.3931L6.87054 9L12 14.2138L17.1295 9L18.5 10.3931L12 17L5.5 10.3931Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol